import styled from "styled-components"

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100svh;
`

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 0 0 64px 0;
`

export const HeaderArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const PageTitle = styled.h1<{ $align?: string }>`
  font-size: 28px;
  font-weight: 700;
  color: #1a1f2e;
  text-align: ${({ $align }) => $align ?? "left"};
  line-height: 1.2;

  @media (max-width: ${({ theme }) => theme.bp.small}px) {
    font-size: 24px;
  }
`

export const EventDateChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  background-color: #f1f5f9;
  color: #475569;
  font-size: 13px;
  font-weight: 500;
  width: fit-content;
  font-variant-numeric: tabular-nums;
  font-feature-settings: "tnum";

  svg {
    width: 14px;
    height: 14px;
  }
`

export const Segmented = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  background-color: #f1f5f9;
  border-radius: 12px;
  width: fit-content;
  max-width: 100%;
  overflow-x: auto;

  /* hide scrollbar */
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: ${({ theme }) => theme.bp.small}px) {
    width: 100%;
  }
`

export const SegmentedButton = styled.button<{ $active: boolean }>`
  appearance: none;
  border: none;
  background-color: ${({ $active }) => ($active ? "#ffffff" : "transparent")};
  color: ${({ $active, theme }) => ($active ? theme.colors.blue.main : "#475569")};
  font-size: 14px;
  font-weight: ${({ $active }) => ($active ? 600 : 500)};
  padding: 0 14px;
  height: 40px;
  min-height: 40px;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  transition: background-color 0.2s ease, color 0.2s ease;
  box-shadow: ${({ $active }) =>
    $active
      ? "0 1px 2px rgba(15, 23, 42, 0.06), 0 1px 3px rgba(15, 23, 42, 0.08)"
      : "none"};

  &:hover {
    background-color: ${({ $active }) =>
      $active ? "#ffffff" : "rgba(255, 255, 255, 0.6)"};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.blue.main};
    outline-offset: 2px;
  }

  @media (max-width: ${({ theme }) => theme.bp.small}px) {
    flex: 1;
    justify-content: center;
  }
`

export const SegmentedCount = styled.span<{ $active: boolean }>`
  font-size: 12px;
  font-weight: 600;
  min-width: 20px;
  padding: 1px 6px;
  border-radius: 999px;
  background-color: ${({ $active, theme }) =>
    $active ? theme.colors.blue.main : "#e2e8f0"};
  color: ${({ $active }) => ($active ? "#ffffff" : "#475569")};
  font-variant-numeric: tabular-nums;
  font-feature-settings: "tnum";
  text-align: center;
`

export const List = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  max-width: 100%;

  @media (max-width: 1239px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: ${({ theme }) => theme.bp.small}px) {
    grid-template-columns: repeat(1, 1fr);
    gap: 16px;
  }
`

export const LoadingWrapper = styled.div`
  width: 256px;
  margin: 40px auto;
`

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 16px;
  padding: 48px 24px;
  max-width: 400px;
  margin: 24px auto;
`

export const EmptyIllustration = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background-color: #eff6ff;
  color: ${({ theme }) => theme.colors.blue.main};

  svg {
    width: 36px;
    height: 36px;
  }
`

export const EmptyTitle = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: #1a1f2e;
  margin: 0;
`

export const EmptyText = styled.p`
  font-size: 15px;
  color: #6b7280;
  line-height: 1.5;
  margin: 0;
`

export const EmptyCta = styled.button`
  appearance: none;
  border: none;
  background-color: ${({ theme }) => theme.colors.blue.main};
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  padding: 0 20px;
  height: 44px;
  min-height: 44px;
  border-radius: 999px;
  cursor: pointer;
  margin-top: 8px;
  transition: background-color 0.2s ease, transform 0.1s ease;

  &:hover {
    background-color: #0052c7;
  }

  &:active {
    transform: translateY(1px);
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.blue.main};
    outline-offset: 3px;
  }
`
